export default "__VITE_ASSET__DJgumrBC__"